import { useSelector, shallowEqual } from 'react-redux';
import { get } from 'lodash';

import constants from '@/utils/constants';
import { RootState } from '@/redux/ducks';
import { IMerchantAttribute } from '@/types';

const { SUPERMERCHANT_GROUP_NAME } = constants;

const checkIfSuperMerchant = (userGroup: string) =>
	userGroup === SUPERMERCHANT_GROUP_NAME;

export const useMerchantPermissions = () => {
	const { merchantDetails, userDetails, selectedMID, onboarding } = useSelector(
		(state: RootState) => ({
			merchantDetails: state.merchantProfile.merchantDetails,
			userDetails: state.userAuth.user,
			selectedMID: state.userAuth.selectedMID,
			onboarding: state.onboarding,
		}),
		shallowEqual,
	);

	const userId = get(userDetails, 'userId');
	const attributes = get(merchantDetails, 'attributes', []);
	const merchantType = get(merchantDetails, 'type', '');
	const currentUserMerchantType = get(
		selectedMID,
		'userGroupNamespace.groupName',
	);
	const currentUserMID = get(selectedMID, 'userGroupNamespace.groupValue');

	const isSuperMerchant = checkIfSuperMerchant(currentUserMerchantType);

	const isMerchantUPIVerified = attributes.some(
		(attribute: IMerchantAttribute) =>
			merchantDetails.merchantId === attribute.merchantId &&
			attribute.type === 'UPI_VERIFIED' &&
			attribute.active &&
			attribute.value,
	);

	const isSplitSettlementEnabled =
		attributes.findIndex(
			(attribute: IMerchantAttribute) =>
				merchantDetails.merchantId === attribute.merchantId &&
				attribute.type === 'SPLIT_SETTLEMENT_ENABLED',
		) >= 0;

	const isB2bPgActivated = get(onboarding, 'isB2bPgActivated', false);
	const isOnlineMerchant = merchantType === constants.ONLINE_MERCHANT;

	return {
		isSuperMerchant,
		isOnlineMerchant,
		isMerchantUPIVerified,
		isB2bPgActivated,
		merchantType,
		currentUserMID,
		userId,
		isSplitSettlementEnabled,
	};
};
